<template>
    <v-container class="pt-0 pl-0 pb-0">
        <v-row v-if="type_view == 0">
            <v-col cols="3" v-for="debt in debts" :key="debt.id">
                <v-card>
                    <v-card-title class="debt-customer">
                        <span class="debtor-name text-truncate" >
                            {{ debt.name }}
                        </span>
                        <v-spacer></v-spacer>
                        
                    </v-card-title>
                    <v-card-subtitle>
                        <span class="caption font-weight-medium">RUC: {{ debt.document }}</span>
                    </v-card-subtitle>
                    <v-card-text class="pb-0">
                        <div class="info-debt">
                            <template>
                                <v-row>
                                    <v-col cols="6">
                                        <span class="span-block subtitle-2">Deuda Total</span>
                                        <span class="span-block debt-amount text-red">{{ debt.total_debt | currency('S/ ')}}</span>
                                    </v-col>
                                    <v-col cols="6">
                                        <span class="span-block subtitle-2">Monto Pagado</span>
                                        <span class="span-block debt-amount text-green">{{ debt.paid_debt | currency('S/ ')}}</span>
                                    </v-col>
                                </v-row>
                            </template>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <div class="btn-view-account">
                            <v-btn small outlined color="#3f51b5" 
                                @click="handleViewDebtDetail(debt)"
                                v-if="verifyPermission('ver_detalle_cuentas')">
                                Ver
                            </v-btn>
                        </div>                        
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="type_view != 0">
            <v-col cols="12" class="pt-0 pr-0">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="debts"
                        item-key="id"
                        height="65vh"
                        fixed-header
                    >
                        <template v-slot:item.total_debt="{item}">
                            <span class="text-red">{{ item.total_debt | currency('S/') }}</span>
                        </template>

                        <template v-slot:item.paid_debt="{item}">
                            <span class="text-green">{{ item.paid_debt | currency('S/') }}</span>
                        </template>

                        <template v-slot:item.pending_debt="{item}">
                            <span class="text-ambar">{{ calculateDebtPending(item) | currency('S/') }}</span>
                        </template>

                        <template v-slot:item.action="{item}">
                            <v-btn small outlined color="#3f51b5" 
                                @click="handleViewDebtDetail(item)"
                                v-if="verifyPermission('ver_detalle_cuentas')">
                                Ver
                            </v-btn>
                        </template>
                    </v-data-table>

                </v-card>
                

            </v-col>
        </v-row>
        
        <account-detail ref="accountDetail"></account-detail>
    </v-container> 
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import AccountDetail from './AccountDetail'

export default {
    name: 'CardAccount',
    data() {
        return {
            headers: [
                { text: 'Proveedor', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'RUC', value: 'document', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Deuda Total', value: 'total_debt', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Monto Pagado', value: 'paid_debt', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Monto Pendiente', value: 'pending_debt', align: 'left', sortable: false, class: 'header-table' },
                { text: '', value: 'action', align: 'left', sortable: false, class: 'header-table' }
            ],
        }
    },
    components: {
        AccountDetail
    },
    computed: {
        ...mapState('provider', [
            'debts',
            'type_view'
        ]),
    },
    methods: {
        ...mapActions('provider', [
            'getDebts',
            'runSetProviderSelected',
            'getDebtsByProvider',
            'getTotalAmount',
            'runSetTypeView'
        ]),
        handleViewDebtDetail(debt){
            this.runSetProviderSelected(null)
            this.runSetProviderSelected(debt)
            this.getDebtsByProvider()
            this.$refs.accountDetail.showForm('Detalle de cuentas por pagar')
        },
        calculateDebtPending(debt){
            let pending_debt = debt.total_debt - debt.paid_debt
            return pending_debt
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created() {
        this.getDebts()
        this.getTotalAmount()
        this.runSetTypeView(1)
    }
}
</script>

<style scoped>
.btn-view-account{
    text-align: right;
    display: block;
    width: 100%;
}

.text-ambar{
    color: #FFC107;
}
</style>